import { TextBox } from 'devextreme-react';
import Button from 'devextreme-react/button';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { getItemApi, postApi } from '../../apiUtils';
import { useAuth } from '../../contexts/auth';
import { Task } from '../../types/task.types';
import { API_URL } from '../../utils/apiUrl';
import { Platform } from '../loginForm/LoginForm';
import './TransactionsSearchForm.scss';

export function TransactionsSearchForm() {
  const [query, setQuery] = useState<string>();
  const { signOut } = useAuth();
  const history = useHistory();

  const submit = async (e) => {
    e.preventDefault();

    // Kontrola, jestli se jedná o Task CustomId
    await getItemApi<Task>({
      url: `${API_URL.TASK_FROM_CUSTOM_ID}?customId=${query}`,
      params: {},
      callAfterSuccess: (res) => {
        setQuery('');
        history.push(`/tasks/edit/${res.id}`);
      },
      callAfterError: async () => {
        // Pokud ne, hledáme transakci
        await postApi({
          url: `${API_URL.TRANSACTION_GET_URL_FROM_SHORTCUT}?shortcut=${query}&platform=${Platform.DESKTOP}`,
          callAfterSuccess: (result) => {
            if (result === '/logout' && signOut) signOut();

            history.push(result);
            setQuery('');
          },
        });
      },
      hideNotifications: true,
    });
  };

  const showHelp = () => {
    history.push('/transactions');
  };

  return (
    <form onSubmit={submit} style={{ display: 'flex' }}>
      <div style={{ float: 'left' }}>
        <TextBox
          placeholder="Enter transaction"
          value={query}
          onValueChanged={(e) => setQuery(e.value)}
        />
      </div>
      <Button icon={'help'} type={'normal'} stylingMode={'contained'} onClick={showHelp} />
    </form>
  );
}
